import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { KEYS } from 'helpers/react-query.config';
import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';

import { transformProblemFlowDataForEdit } from '../utils';

type Props = {
  statusFlowId: number | null | undefined;
};

function useGetStatusFlowById({ statusFlowId }: Props) {
  const { t } = useTranslation('global');
  const { showApiError } = useGlobalContext();
  const { processApi } = useApiContext();

  return useQuery(
    [KEYS.process.problemFlow.getById(statusFlowId), statusFlowId],
    () =>
      processApi.ProblemFlow.generalSearchProblemStatusFlowById(statusFlowId),
    {
      enabled: !!statusFlowId,
      refetchOnWindowFocus: false,
      select: ({ data }) => {
        const { name, id, enabled, base, clientId } = data.data;
        return {
          name,
          id,
          enabled,
          base,
          clientId,
          data: transformProblemFlowDataForEdit(data?.data) || []
        };
      },
      onError: (error) =>
        showApiError(error, t('common.commonMessages.genericRequestError'))
    }
  );
}

export default useGetStatusFlowById;
